import qs from 'query-string';

function getBrokerFromURL() {
  const queryParamsObj = qs.parse(window.location.search);
  let { broker: brokerName } = queryParamsObj;
  if (brokerName !== undefined) {
    brokerName = brokerName.toLowerCase();
    // Remove leprechaun from broker key, if it is present
    brokerName = brokerName.replace('-leprechaun', '');
  }

  return brokerName;
}

function getBrokerDisplayNameFromURL(brokerMap) {
  const brokerKey = getBrokerFromURL();
  if (brokerKey !== undefined) {
    for (const broker of brokerMap) {
      if (broker.broker === brokerKey) {
        return broker.brokerDisplayName;
      }
    }
  }
  return '';
}

function getBrokerShortNameFromURL(brokerMap) {
  const brokerKey = getBrokerFromURL();
  if (brokerKey !== undefined) {
    for (const broker of brokerMap) {
      if (broker.broker === brokerKey) {
        return broker.brokerShortName;
      }
    }
  }
  return '';
}

function getGatewayLoginConsentFromURL(brokerMap) {
  const brokerKey = getBrokerFromURL();
  if (brokerKey !== undefined) {
    for (const broker of brokerMap) {
      if (broker.broker === brokerKey) {
        return broker.gatewayLoginConsent;
      }
    }
  }
  return '';
}

function getParamsFromURL() {
  return qs.parse(window.location.search);
}

// eslint-disable-next-line import/prefer-default-export
export {
  getBrokerDisplayNameFromURL,
  getBrokerFromURL,
  getParamsFromURL,
  getBrokerShortNameFromURL,
  getGatewayLoginConsentFromURL,
};



// WEBPACK FOOTER //
// ./utils/brokerUtils.js